import React from 'react';
import StyledTable from '@shared/components/StyledTable';
import constants from '@shared-styles/constants.module.scss';
import { isNumKeyValid } from '../../../../../utils/numberExtensions';
import INSTANCE_TRENDS from '../../../constants/instanceTrends';

const INSTANCE_TRENDS_TO_TEXT_MAP = {
  [INSTANCE_TRENDS.STRENGTH]: 'Strength',
  [INSTANCE_TRENDS.CHALLENGE]: 'Challenge'
};

const INSTANCE_TRENDS_TO_COLOR_MAP = {
  [INSTANCE_TRENDS.STRENGTH]: constants.isacaMediumBlueWithOpacity,
  [INSTANCE_TRENDS.CHALLENGE]: constants.isacaOrangeWithOpacity
};

/**
 * @typedef {object} TotalReportTableProps
 * @property {Array<*>} [data]
 * @property {boolean} [loading]
 */

/**
 * @param {TotalReportTableProps} props
 */
const TotalReportTable = props => {
  const { data = [], loading = false } = props;

  const columns = [
    {
      title: 'Practice',
      dataIndex: 'practice',
      render: (text, record) => <div title={record.hoveringText}>{text}</div>,
      key: 'practice',
      sorter: (a, b) => a.practice.localeCompare(b.practice),
      width: '20%'
    },
    {
      title: 'Trend',
      dataIndex: 'trend',
      onCell: record => {
        return {
          style: {
            backgroundColor: INSTANCE_TRENDS_TO_COLOR_MAP[record.trend]
          }
        };
      },
      render: val => INSTANCE_TRENDS_TO_TEXT_MAP[val],
      key: 'trend',
      sorter: (a, b) => a.trend - b.trend,
      width: '20%'
    },
    {
      title: 'All Instances Satisfied',
      dataIndex: 'satisfiedPercentage',
      render: text => text + '%',
      key: 'satisfiedPercentage',
      sorter: (a, b) => a.satisfiedPercentage - b.satisfiedPercentage,
      width: '20%'
    },
    {
      title: 'All Instances Aggregate',
      dataIndex: 'aggregatePercentage',
      render: text => text + '%',
      key: 'aggregatePercentage',
      sorter: (a, b) => a.aggregatePercentage - b.aggregatePercentage,
      width: '20%'
    },
    {
      title: 'All Instances Count',
      dataIndex: 'count',
      render: text => text,
      key: 'count',
      sorter: (a, b) => a.count - b.count,
      width: '20%'
    }
  ];

  const handleKeyDown = e => {
    if (!isNumKeyValid(e)) {
      e.preventDefault();
    }
  };

  return (
    <StyledTable
      rowKey='practice'
      dataSource={data}
      columns={columns}
      pagination={{
        showSizeChanger: {
          onInputKeyDown: handleKeyDown
        }
      }}
      showSorterTooltip={false}
      loading={loading}
    />
  );
};

export default TotalReportTable;
